import React, { useState, useEffect, useCallback } from 'react';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import SignInForm from './forms/SignInForm/SignInForm';
import LoginForm from './forms/LoginForm/LoginForm';
import http, { fetcher } from 'app/http';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import PasswordReset from 'templates/LoginPageData/components/PasswordResetModal/PasswordReset';
import OTPVerification from './forms/OTPVerification/OTPVerification';
import Modal from 'components/Modal/Modal';
import { useAppDispatch } from 'app/hooks';
import { removeCoreData } from 'features/core/reducer';
import { getGTMVariables, getGTMVariablesPageView, getEncryptedValue  } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getParamValue } from 'common/helpers/urlParams';

type Props = {
  Model: any;
  PageData: any;
  LayoutModel?: any;
};

export enum FORM_MODE {
  LOGIN = 'login',
  SIGN_IN = 'signin',
  RESET = 'loginReset',
}

export enum RESET_FORM_STEP {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
}

const LoginPageData = ({ Model, PageData, LayoutModel }: Props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [showPasswordRemind, setShowPasswordRemind] = useState<boolean>(false);
  const [disableSendCodeSubmit, setDisableSendCodeSubmit] = useState<boolean>(false);
  const [resetStep, setResetStep] = useState<RESET_FORM_STEP>(
    RESET_FORM_STEP.FIRST,
  );
  const [passwordRemindData, setPasswordRemindData] = useState<any>({
    undefined,
  });
  const [cleanForm, setCleanForm] = useState<boolean>(false);
  const [redirectToReset, setRedirectToReset] = useState<boolean>(Model?.RedirectToReset);
  const [isOTPSubmitted, setIsOTPSubmitted] = useState<boolean>(false);
  
  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = ''
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

  var tagManagerArgs: any;
  useEffect(() => {
    if (Model.IsRegistrationJourney) {
      tagManagerArgs = {
        dataLayer: {
          event: 'verification_success',
          checkout_name: 'Registration',
          verification_method: Model.VerificationMethod
        }
      };
      TagManager.dataLayer(tagManagerArgs);

      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Registration',
          checkout_step_number: '4'
        }
      };
      TagManager.dataLayer(tagManagerArgs);
    };
  }, [Model.IsRegistrationJourney]);

  const trackLoginSuccessEvent = (redirectURL: string) => {
    var debtReferenceValue = getParamValue(redirectURL, 'debtReference')
    var tagManagerArgs: any;
    if (debtReferenceValue) {
      let encodedUserId = getEncryptedValue(debtReferenceValue,LayoutModel?.CountryCode)
      tagManagerArgs = {
        dataLayer: {
          event: 'login',
          user_id: encodedUserId
        }
      };
      TagManager.dataLayer(tagManagerArgs);
    }
    else {
      tagManagerArgs = {
        dataLayer: {
          event: 'login',
        }
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }

  const fetchPasswordRemindData = useCallback(async () => {
    try {
      const response = await http.post(Model?.ResetUrl);
      if (response.data) {
        setPasswordRemindData(response.data);
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  const trackloginResetSuccess = (debtReferenceValue: string) => {
    var tagManagerArgs: any;
    if (debtReferenceValue) {
      let encodedUserId = getEncryptedValue(debtReferenceValue, LayoutModel?.CountryCode)
      tagManagerArgs = {
        dataLayer: {
          event: 'forgot_password_success',
          reset_type: 'Email',
          user_id: encodedUserId
        }
      };
      TagManager.dataLayer(tagManagerArgs);
    }
    else {
      tagManagerArgs = {
        dataLayer: {
          event: 'forgot_password_success',
          reset_type: 'Email',
        }
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }

  const handleLoginSubmit = async (data: any) => {
    try {
      const pathname = getPathnameFromUrl(Model.NextUrl);
      const response = await fetcher.post(pathname, qs.stringify(data));
      setCleanForm(true);
      if (response.data.RedirectUrl) {
        const redirectPath = getPathnameFromUrl(response.data.RedirectUrl);
        if (redirectPath.indexOf('app/authorize') > 0) {
          const responseAppAuthorize = await fetcher.get(redirectPath);
          if (responseAppAuthorize.data.RedirectUrl) {
            dispatch(removeCoreData());
            const redirectPathFromAppAuthorize = getPathnameFromUrl(responseAppAuthorize.data.RedirectUrl);
           console.log("redirectPathFromAppAuthorize", redirectPathFromAppAuthorize);
            redirectPathFromAppAuthorize.indexOf('app/logout') > 0 ? window.location.href = redirectPathFromAppAuthorize :
            trackLoginSuccessEvent(redirectPath); 
            window.location.href = redirectPathFromAppAuthorize;            
            return;
          }
        }
        if (redirectPath) {
          console.log("redirectPath",redirectPath);
          history.push(redirectPath);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSignInSubmit = async (data: any) => {
    try {
      const currentURL = window.location.href;
      var debtReferenceValue = getParamValue(currentURL, 'debtReference') || "";

      const pathname = getPathnameFromUrl(Model.NextUrl);
      const response = await fetcher.post(pathname, qs.stringify(data));

      if (response.data.RedirectUrl) {
        const redirectPath = getPathnameFromUrl(response.data.RedirectUrl);
        if (redirectPath.indexOf('app/authorize') > 0) {
          const responseAppAuthorize = await fetcher.get(redirectPath);
          if (responseAppAuthorize.data.RedirectUrl) {
            dispatch(removeCoreData());
            const redirectPathFromAppAuthorize = getPathnameFromUrl(responseAppAuthorize.data.RedirectUrl);
            if (redirectPathFromAppAuthorize.indexOf('app/resetsuccessful') > 0) {
              trackloginResetSuccess(debtReferenceValue);
            }
            redirectPathFromAppAuthorize.indexOf('app/logout') > 0 ? window.location.href = redirectPathFromAppAuthorize :
              history.push(redirectPathFromAppAuthorize);
            return;
          }
        }
        if (redirectPath) {
          history.push(redirectPath);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (redirectToReset == true) {
      setResetStep(RESET_FORM_STEP.FIRST)
    }
  }, [redirectToReset, setRedirectToReset]);

  useEffect(() => {
    if (resetStep === RESET_FORM_STEP.FIRST) {
      fetchPasswordRemindData();
    }
  }, [fetchPasswordRemindData, resetStep]);

  const onVerifyEmailOrMobileNumber = async (data: any) => {
    try {    
      setDisableSendCodeSubmit(true)  
      const verifyResponse = await fetcher.post(
        Model?.VerifySMSUrl,
        qs.stringify(data),
      );
      if (verifyResponse.data.status){
          if(verifyResponse.data.status == "error")
          {
            var nextPagePath = getPathnameFromUrl(verifyResponse.data.data);
            history.push(nextPagePath, {
              noRefresh: false,
            });
            return;
        }
      }
      if (verifyResponse.data.RedirectUrl) {
        const otpFormResponse = await fetcher.get(
          verifyResponse.data.RedirectUrl,
        );        
        setPasswordRemindData({
          PageData: otpFormResponse?.data?.PageData,
          Model: otpFormResponse?.data?.Model,
        });
        setResetStep(RESET_FORM_STEP.SECOND);
      } else {
        setPasswordRemindData({
          PageData: verifyResponse?.data?.PageData,
          Model: verifyResponse?.data?.Model,
        });
      }
    } catch (error) {
      console.error(error);
    }
    finally{
      setDisableSendCodeSubmit(false)  
    }
    
  };

  const onVerifyOTP = async (data: any) => {
    try {
      setIsOTPSubmitted(true);
      const response = await fetcher.post(
        passwordRemindData?.Model.PostCodeLink,
        qs.stringify(data),
      );
      if (response.data && response.data.status) {
        const redirectPath = getPathnameFromUrl(response.data.data);
        history.push(redirectPath);
      }
      if (response.data) {
        setPasswordRemindData(response.data);
      }
    } catch (error) { }
    finally {
      setIsOTPSubmitted(false);
    }
  };

  return (
    <>
      {Model.FormModel.Mode === FORM_MODE.SIGN_IN ||
        Model.FormModel.Mode === FORM_MODE.RESET ? (
        <SignInForm
          Model={Model}
          PageData={PageData}
          onSubmit={handleSignInSubmit}
        />
      ) : (
        <>
          <GoogleReCaptchaProvider reCaptchaKey={Model?.ReCaptchaKey}>
            <LoginForm
              Model={Model}
              PageData={PageData}
              cleanForm={cleanForm}
              onSubmit={handleLoginSubmit}
              onShowResetForm={() => setShowPasswordRemind(!showPasswordRemind)}
            />            
            {(showPasswordRemind || redirectToReset) && (
              <Modal showCloseButton onClose={() => { setShowPasswordRemind(false); setRedirectToReset(false); }}>
                {(resetStep === RESET_FORM_STEP.FIRST) && (

                  <PasswordReset
                    {...passwordRemindData}
                    onSubmit={(data) => onVerifyEmailOrMobileNumber(data)}
                    onCancel={() => { setShowPasswordRemind(!showPasswordRemind); setRedirectToReset(false); }}
                    disableSubmit = {disableSendCodeSubmit}
                    setDisableSubmit = {setDisableSendCodeSubmit}
                  />

                )}
                {(resetStep === RESET_FORM_STEP.SECOND) && (
                  <OTPVerification
                    {...passwordRemindData}
                    onSubmit={(data) => onVerifyOTP(data)}
                    onCancel={() => setPasswordRemindData(!showPasswordRemind)}
                    onBack={() => setResetStep(RESET_FORM_STEP.FIRST)}
                    isOTPSubmitted={isOTPSubmitted}
                    countrycode={LayoutModel?.CountryCode}
                  />
                )}
              </Modal>
            )}
          </GoogleReCaptchaProvider>          
        </>
      )}
    </>
  );
};

export default LoginPageData;
